import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { showError } from '../../utils/alertsUtils'
import { TrendingCardList } from "../../layout/trendingCardList/trendingCardList.component"
import { ProfileCard } from "../profileCard/profileCard.component"
import { CustomRadioSelection } from "../customRadioSelection/customRadioSelection.component"
import { CustomTextField } from "../customTextField/customTextField.component"
import { getExpectedOutcomes, getImplementAreas, postNewIdea, uploadAttachment } from '../../services/ideas.service'
import { CustomDropdown } from "../customDropdown/customDropdown.component"
import { UploadingButton } from '../uploadingButton/uploadingButton.component'
import { CustomLoader } from '../customLoader/customLoader.components'
import { useNavigate } from 'react-router-dom'

import logo from '../../assets/images/new-logo.png'

export const PhuketForm = () => {
    const [ideaTitle, setIdeaTitle] = useState("")
    const [ideaDesc, setIdeaDesc] = useState("")
    const [isImplemented, setIsImplemented] = useState(0)
    const [isImplementedText, setIsImplementedText] = useState("")
    const [isForDepartment, setIsForDepartment] = useState(0)
    const [benefits, setBenefits] = useState("")
    const [implementArea, setImplementArea] = useState('')
    const [outcomeArea, setOutcomeArea] = useState('')
    const [expectedOutcomeList, setExpectedOutcomeList] = useState([])
    const [implementAreasList, setIsImplementAreasList] = useState([])
    const [files, setFiles] = useState([])
    const [isPosting, setIsPosting] = useState(false)
    const navigator = useNavigate()

    useEffect(() => {
        const getDropDownData = async () => {
            const { status: implementStatus, data: implementData } = await getImplementAreas()
            if (implementStatus == 200) {
                setIsImplementAreasList(implementData)
            }
            const { status: outcomeStatus, data: outcomeData } = await getExpectedOutcomes()
            if (outcomeStatus == 200) {
                setExpectedOutcomeList(outcomeData)
            }
        }
        getDropDownData()
    }, [])

    const validateFormData = () => {
        if (ideaDesc == "") {
            showError("Please Describe Your Innovation.")
            return false
        }
        if (isImplemented == 1 && isImplementedText == "") {
            showError("Please Describe Implemented area.")
            return false
        }
        if (implementArea == "") {
            showError("Please Select Implement Area.")
            return false
        }
        if (benefits == "") {
            showError('Please Describe Benefits.')
            return false
        }
        else {
            let isUploading = false
            files.map((file) => {
                if (file.isUploading) {
                    isUploading = true
                }
            })
            if (isUploading) {
                showError("Your file being uploaded.")
                return false
            }
            return true
        }
    }
    const postIdea = async () => {
        const isValidated = validateFormData()
        const postType = "campaign"
        if (isValidated) {
            setIsPosting(true)
            const response = await postNewIdea(ideaDesc, isImplemented, isImplementedText, implementArea, isForDepartment, benefits, files, postType, outcomeArea)
            if (response.status == 200) {
                setIsPosting(false)

                navigator('/')
            } else {
                window.alert("Network Error")
            }
        }
    }

    const getAttachement = async (e, type) => {
        const fileExt = e.target.files[0].name.split('.')[1].toLowerCase() || "txt"
        if (e.target.files[0].size > 5000000) {
            return showError("You cannot upload more than 5mb attachment.")
        }
        if (type == "img-upload") {
            if (fileExt !== 'jpg' && fileExt !== 'jpeg' && fileExt !== 'png') {
                return showError("Only jpg, jpeg and png files are supported.")
            }
        }
        if (type == "vid-upload") {
            if (fileExt !== 'mp4') {
                return showError("Only mp4 files are supported.")
            }
        }
        if (type == "doc-upload") {
            if (fileExt !== 'pdf') {
                return showError("Only pdf files are supported.")
            }
        }
        if (type == "aud-upload") {
            if (fileExt !== 'mp3') {
                return showError("Only mp3 files are supported.")
            }
        }
        const fileIndex = e.target.files.length - 1
        const file = e.target.files[fileIndex]
        file.isUploading = true
        file.cancelToken = axios.CancelToken.source();
        const path = (window.URL || window.webkitURL).createObjectURL(e.target.files[0])
        file.path = path
        setFiles(oldFiles => [...oldFiles, file])
        const fileData = new FormData()
        fileData.append("attachment", e.target.files[fileIndex])

        const response = await uploadAttachment(fileData, setFiles, file.name, file.cancelToken)
        if (response) {
            if (response.data.isUploaded) {
                setFiles((prevState) =>
                    prevState.filter((prevItem) => {
                        if (prevItem.name == file.name) {
                            prevItem.isUploading = false
                            prevItem.data = response.data
                        }
                        return prevItem
                    })
                );
            }
        }
    }

    const removeAttachment = async (path, fileName) => {
        setFiles((prevState) =>
            prevState.filter((prevItem) => {
                if (prevItem.path !== path) {
                    return prevItem
                }
            })
        );
    }


    return (
        <>
            <CustomLoader isLoading={isPosting} />
            <div className="app-content content">
                <div className="content-overlay"></div>
                <div className="header-navbar-shadow">
                    <img src={logo} className="d-none d-lg-block" alt="img" />
                </div>
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-12 col-lg-9">
                                <h2 className="text-uppercase mb-0">
                                    <span className="star-orange">Share</span> Your Idea
                                </h2>

                                <p className="font-lato font-12">You feel you have come up with an innovative way to solve a problem that is relevant for your practice, the broader firm and or clients. We would like to know...</p>
                                {/* <CustomTextField fieldName={"Title"} setText={setIdeaTitle} /> */}
                                <CustomTextField fieldName={"DESCRIBE YOUR IDEA"} setText={setIdeaDesc} files={files} removeAttachment={removeAttachment}>
                                    <UploadingButton htmlFor={"img-upload"} id={"img-upload"} iconClass={"fas fa-image"} acceptInputType={".jpg, .jpeg, .png"} getAttachement={getAttachement} />
                                    <UploadingButton htmlFor={"vid-upload"} id={"vid-upload"} iconClass={"fas fa-video"} acceptInputType={".mp4"} getAttachement={getAttachement} />
                                    <UploadingButton htmlFor={"doc-upload"} id={"doc-upload"} iconClass={"fas fa-file-alt"} acceptInputType={".pdf"} getAttachement={getAttachement} />
                                    <UploadingButton htmlFor={"aud-upload"} id={"aud-upload"} iconClass={"fas fa-music"} acceptInputType={".mp3"} getAttachement={getAttachement} />
                                </CustomTextField>
                                <CustomRadioSelection
                                    heading={"Is this something we have implemented somewhere?"}
                                    inputName={"radio1"}
                                    inputIdOne={"radioa"}
                                    inputIdTwo={"radiob"}
                                    OptionOneValue={"Yes"}
                                    OptionTwoValue={"No"}
                                    isTextRequired={true}
                                    setFieldState={setIsImplemented}
                                    setText={setIsImplementedText} />
                                {/* <CustomRadioSelection
                                    heading={"IS THIS IDEA FOR YOUR DEPARTMENT ?"}
                                    inputName={"radio2"}
                                    inputIdOne={"radioc"}
                                    inputIdTwo={"radiod"}
                                    OptionOneValue={"Yes"}
                                    OptionTwoValue={"No"}
                                    isTextRequired={false}
                                    setFieldState={setIsForDepartment} /> */}
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <CustomDropdown name={"Which department is this relevant for?"} options={implementAreasList} setOptionValue={setImplementArea} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <CustomDropdown name={"What is the outcome expected through this innovation?"} options={expectedOutcomeList} setOptionValue={setOutcomeArea} />
                                    </div>
                                </div>
                                <CustomTextField fieldName={"BENEFITS"} setText={setBenefits} />
                                <button type="button" className="btn btn-primary text-white rounded-10 font-11 font-lato" onClick={postIdea}><i
                                    className="fas fa-lightbulb mr-1" ></i>Share</button>
                            </div>
                            <div className="col-12 col-lg-3">
                                <ProfileCard />
                                <TrendingCardList />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}